<template>
  <div>
    <jd-form
      :form-info="getCollectFormInfo"
      @search="searchCollectOpportunities"
      class="mt16 mb16"
    />
    <div class="mb12 flex-spc-x">
      <div>
        <jd-button
          @click="addCrowd"
          :disabled="!collectOpportunitiesList.length"
          >按查询结果生成人群</jd-button
        >
        <jd-button @click="isShowAddGiftNumberBatch = true"
          >收集次数变更（批量）</jd-button
        >
      </div>
      <jd-button @click="exportCollect" type="text" v-preventReClick
        >导出</jd-button
      >
    </div>
    <!-- 表格 -->
    <jd-table
      :tableData="collectOpportunitiesList"
      :pageInfo="{
        pageNum: collectForm.current,
        pageSize: collectForm.size,
        total: collectOpportunitiesTotal,
      }"
      @handlePage="handlePage"
      :loading="loading"
    >
      <el-table-column :prop="chaosParams" :label="`用户${grayText()}`" width="150">
      </el-table-column>
      <el-table-column prop="memberNick" label="用户昵称"> </el-table-column>
      <el-table-column label="关联订单号">
        <template slot-scope="scope">
          <el-tooltip placement="top" popper-class="new-tooltip-width">
            <div slot="content">
              {{ scope.row.orderListStr }}
            </div>
            <div
              style="
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              "
            >
              {{ scope.row.orderListStr }}
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="taskTypeStr" label="获取方式"></el-table-column>
      <el-table-column prop="giveTimes" label="赠送机会次数"></el-table-column>
      <el-table-column label="许愿心愿">
        <template slot-scope="scope">
          <span>{{ scope.row.wishContent ? scope.row.wishContent : "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="获取时间">
        <template slot-scope="scope">
          <span>{{ scope.row.joinTime ? scope.row.joinTime : "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="sellerLinkName" label="投放渠道"></el-table-column>
    </jd-table>
    <!-- 收集次数变更（批量） -->
    <addGiftNumberBatch
      v-if="isShowAddGiftNumberBatch"
      titleText="收集"
      :activityId="activityId"
      @close="handleCloseAddGiftNumberBatch"
    ></addGiftNumberBatch>
  </div>
</template>
<script>
import { taskCompletion } from "@/api/jhk/integralCenter/PointActivityAnalyticController";
import addGiftNumberBatch from "./addGiftNumberBatch.vue";
export default {
  name: "birthInfo",
  components: {
    addGiftNumberBatch,
  },
  props: {
    collectInfoFormList: {
      type: Array,
      default: () => [{}],
    },
    activityId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isShowAddGiftNumberBatch: false,
      loading: false,
      collectOpportunitiesTotal: 0,
      collectOpportunitiesList: [],
      collectForm: {
        sellerLinkId: "",
        pin: "",
        taskType: "",
        startTime: "",
        endTime: "",
        size: 10,
        current: 1,
      },
    };
  },
  computed: {
    getCollectFormInfo: {
      get() {
        return this.collectInfoFormList;
      },
      set(val) {
        this.$emit("update:collectInfoFormList", val);
      },
    },
    searchGrayId() {
      return this.$store.getters.loginUserInfo.isGray ? 'xid' : 'pin'
    },
    grayText() {
      return this.$store.getters.loginUserInfo.isGray ? 'xid' : 'pin（加密）'
    },
    chaosParams() {
      return this.$store.getters.loginUserInfo.isGray ? 'chaosXid' : 'chaosPin'
    },
  },
  watch: {
    searchGrayId: {
      handler(newVal, oldVal) {
        this.formSchema.forEach((item)=>{
          if(item.prop=='pin') {
            item.label = item.label.replace(/pin/ig, newVal)
            item.prop = newVal;
            item.placeholder = item.placeholder.replace(/pin/ig, newVal)
          }
        })
      },
      deep: true,
      immediate: true,
    }
  },
  mounted() {
    this.getCollectOpportunitiesDetail();
  },
  methods: {
    handleCloseAddGiftNumberBatch(flag) {
      this.isShowAddGiftNumberBatch = false;
      if (flag) {
        this.getCollectOpportunitiesDetail();
      }
    },
    // 导出获取机会记录
    exportCollect() {
      this.$emit("exportTask");
    },
    addCrowd() {
      this.$emit("addCrowd", 7);
    },
    handlePage(page) {
      this.collectForm.current = page.pageNum;
      this.collectForm.size = page.pageSize;
      this.getCollectOpportunitiesDetail();
    },
    getCollectOpportunitiesDetail() {
      this.loading = true;
      taskCompletion({ ...this.collectForm, activityId: this.activityId })
        .then((res) => {
          this.loading = false;
          if (res.code == 1) {
            this.collectOpportunitiesList = res.data.records || [];
            this.collectOpportunitiesTotal = +res.data.total;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    searchCollectOpportunities(val) {
      // this.collectForm.pin = val.pin ? val.pin : "";
      this.collectForm[this.searchGrayId] = val[this.searchGrayId] || ""
      this.collectForm.memberNick = val.memberNick ? val.memberNick : "";
      this.collectForm.taskType = val.taskType ? val.taskType : "";
      this.collectForm.startTime = val.startTime ? val.startTime : "";
      this.collectForm.endTime = val.endTime ? val.endTime : "";
      this.collectForm.sellerLinkId = val.sellerLinkId ? val.sellerLinkId : "";
      this.collectForm.size = 10;
      this.collectForm.current = 1;
      this.getCollectOpportunitiesDetail();
    },
  },
};
</script>
<style lang="scss" scoped></style>
